<template>
  <button class="button-menu-mobile open-left" @click="sidebarToggle">
    <i class="mdi mdi-menu"></i>
  </button>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'

import { storeToRefs } from 'pinia'

import { event } from 'vue-gtag'

import { useSideMenuStore } from '@/stores/helpers/sideMenu.js'
import { useAuthStore } from '@/stores/retailer/auth.js'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
    required: false
  }
})

const authStore = useAuthStore()
const sideMenuStore = useSideMenuStore()
const clickable = ref(true)

const { user } = storeToRefs(authStore)
const { sidebarActive } = storeToRefs(sideMenuStore)
const noSalesChannels = computed(() => user.value?.retailer?.sales_channels?.length === 0)

const sidebarToggle = () => {
  if (sidebarActive.value) {
    closeMenu()
  } else {
    openMenu()
  }
  window.dispatchEvent(new Event('resize'))

  const eventActionValues = {
    event_action: sidebarActive.value ? 'menu_opened' : 'menu_hidden'
  }

  event('page_actions', eventActionValues)
}

const openMenu = () => {
  if (clickable.value === true) {
    clickable.value = false
    document.body.className = 'sidebar-enable'
    sideMenuStore.setSidebarCollapseState(true)
    clickable.value = true
    document.body.setAttribute('data-leftbar-compact-mode', 'scrollable')
    localStorage.setItem('sidebarOpened', '1')
  }
}

const closeMenu = () => {
  if (clickable.value === true) {
    clickable.value = false
    document.body.className = 'enlarged'
    sideMenuStore.setSidebarCollapseState(false)
    clickable.value = true
    document.body.setAttribute('data-leftbar-compact-mode', 'condensed')
    localStorage.setItem('sidebarOpened', '0')
  }
}

const documentClick = e => {
  if (mobileCheck()) {
    const element = document.querySelector('.button-menu-mobile')
    const el = document.querySelector('.left-side-menu')
    const target = e?.target || null
    if (
      element &&
      element !== target &&
      !element.contains(target) &&
      !el.contains(target) &&
      e.target.className !== 'left-side-menu' &&
      sidebarActive.value
    ) {
      closeMenu()
    }
  }
}

const mobileCheck = () => {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true
  }

  return false
}

onMounted(() => {
  document.body.className = mobileCheck() ? 'enlarged' : 'sidebar-enable'
  document.addEventListener('click', documentClick)

  if (mobileCheck() === false) {
    return openMenu()
  }
})

onUnmounted(() => {
  document.removeEventListener('click', documentClick)
})

watch(
  () => props.isOpen,
  (newValue, oldValue) => {
    if (!oldValue && newValue) {
      openMenu()
    } else if (oldValue && !newValue) {
      closeMenu()
    }
  }
)
</script>

